import { render, staticRenderFns } from "./DealersPrices.vue?vue&type=template&id=28dbc34c&scoped=true"
import script from "./DealersPrices.vue?vue&type=script&lang=js"
export * from "./DealersPrices.vue?vue&type=script&lang=js"
import style0 from "./DealersPrices.vue?vue&type=style&index=0&id=28dbc34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbc34c",
  null
  
)

export default component.exports